export default "__VITE_ASSET__DNTZuhPY__"